import { Box, Typography } from '@mui/material';

import GoLogo from '@/components/GoLogo';
import Loader from '@/components/Loader';
import { spacing } from '@/constants/ui';
import { BaseLayout } from '@/layouts/BaseLayout';
import { CenteredLayout } from '@/layouts/CenteredLayout';

const LoadingPage = () => {
  return (
    <BaseLayout>
      <CenteredLayout>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: spacing[4]
          }}
        >
          <GoLogo size={74} />
          <Loader />
          <Typography variant='h1'>Please wait...</Typography>
        </Box>
      </CenteredLayout>
    </BaseLayout>
  );
};
export default LoadingPage;
